// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"8985beebc751be898e23","293":"ecf3cb2fd7672159306e"}[chunkId] + ".js";
};